<script lang="ts" setup>
import {
  RegisterData,
  emailRules,
  passwordRules,
  firstnameRules,
  lastnameRules,
} from '@/models/login.model';
import { Actions, ShiftCMSState } from '@/store';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState>();
const router = useRouter();

const valid = ref<boolean>(true);
const registerData = ref<RegisterData>({
  email: '',
  password: '',
  firstName: '',
  lastName: '',
});

const register = async () => {
  if (valid.value) {
    const success = await store.dispatch(Actions.Register, registerData.value);

    if (success) {
      router.push('/login');
    }
  }
};
</script>
<template>
  <v-card width="50%" class="mx-auto register-form" elevation="4">
    <v-form v-model="valid" @submit.prevent="register">
      <v-container>
        <h2>Register</h2>
        <v-row>
          <v-col md="6" class="mx-auto">
            <v-text-field
              v-model="registerData.firstName"
              :rules="firstnameRules"
              label="First name"
              required
            ></v-text-field>
          </v-col>
          <v-col md="6" class="mx-auto">
            <v-text-field
              v-model="registerData.lastName"
              :rules="lastnameRules"
              label="Last name"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" class="mx-auto">
            <v-text-field
              v-model="registerData.email"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>
          </v-col>
          <v-col md="6" class="mx-auto">
            <v-text-field
              v-model="registerData.password"
              :rules="passwordRules"
              label="Password"
              type="password"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col col="2"></v-col>
          <v-col>
            <v-btn class="mt-2" type="submit" block>Submit</v-btn>
          </v-col>
          <v-col col="2"></v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>
<style scoped>
.register-form {
  margin-top: 80px;
}
</style>
